import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  width: ${(p) => p.wrapperWidth};
  height: ${(p) => p.wrapperHeight};
  justify-content: ${({ align }) => {
    if (align === 'left') return 'flex-start'
    if (align === 'right') return 'flex-end'
    return 'center'
  }};
  align-items: center;

  ${(p) =>
    p.isCircle &&
    `
    border-radius: 50%;
    overflow: hidden;
  `}

  &:hover {
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
  }

  & > svg,
  & > img {
    width: ${(p) => p.width};
    height: ${(p) => p.height};
  }
`

const Icon = ({
  style,
  className,
  renderImage,
  align,
  wrapperWidth,
  wrapperHeight,
  width,
  height,
  isCircle,
  onClick,
}) => (
  <Wrapper
    style={style}
    className={className}
    align={align}
    wrapperWidth={wrapperWidth}
    wrapperHeight={wrapperHeight}
    width={width}
    height={height}
    isCircle={isCircle}
    onClick={onClick}
  >
    {renderImage && renderImage()}
  </Wrapper>
)

export default Icon
